'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  empty: '',
  validating: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.validating"
  }),
  success: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.success"
  }),
  error: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.error"
  })
};